import { times } from 'lodash';
import React from 'react';
import ContentLoader from 'react-content-loader';

export const FiltersChipLoader = (props: any) => (
  <div style={{ minWidth: 150, height: 60 }}>
    <ContentLoader
      speed={2}
      width={150}
      height={60}
      viewBox="0 0 150 60"
      backgroundcolor="#f3f3f3"
      foregroundcolor="#ecebeb"
      {...props}
    >
      <rect x="17" y="10" rx="5" ry="5" width="130" height="35" />
    </ContentLoader>
  </div>
);
const FiltersContentLoader = ({ chipCount = 7 }) => (
  <div style={{ display: 'flex', flexWrap: 'wrap' }}>
    {times(chipCount).map((index: number) => (
      <FiltersChipLoader key={`chip_loader_${index}`} />
    ))}
  </div>
);

export default FiltersContentLoader;
